export var portModel = {
   'name': {
      'title': "Port Number",
      'display': true
   },
   'device_id': {
      'title': "Device ID",
      'display': false,
      'metadata': true
   },
   'port_type': {
      'title': "Port Type",
      'display': true
   },
   'mapped_device': {
      'title': "Mapped Device ID",
      'display': false
   },
   'mapped_device_name': {
      'title': "Mapped Device",
      'display': true
   },
   'expiration': {
      'title': "Expiration",
      'display': false
   },
   'unusable': {
      'title': "Broken/Unusable",
      'display': false
   }
};
export const portTypes = [
   'Ethernet',
   'Fiber',
   'Power',
   'Video',
   'USB',
   'Generic'
];